import { EUserDocumentType } from '../enums/user-document-type.enum';

export const UserIdentityDocumentTypeOptions = [
    { value: EUserDocumentType.CPF, label: 'CPF' },
    { value: EUserDocumentType.RG, label: 'RG' },
    { value: EUserDocumentType.CNH, label: 'CNH' },
];

export const UserLaborDocumentTypeOptions = [
    { value: EUserDocumentType.PIS, label: 'PIS' },
    { value: EUserDocumentType.CTPS, label: 'CTPS' },
    { value: EUserDocumentType.TITULO_ELEITOR, label: 'Título de eleitor' },
    { value: EUserDocumentType.RESERVISTA, label: 'Reservista' },
    { value: EUserDocumentType.OTHER, label: 'Outro' },
];
